import type { ReactNode } from 'react'

import { AiChatMessage, AiChatDataPart } from '../../types/aiChat.types'
import { stripResidualTokens } from '../../utils/stripResidualTokens'
import { AnswerMarkdown } from './AnswerMarkdown'
import classes from './Answer.module.scss'

export type AnswerProps = Readonly<{
  message: AiChatMessage
  /** Render the message's domain data parts (e.g. insights renders `metric` cards). */
  renderData?: (data: readonly AiChatDataPart[]) => ReactNode
  testId?: string
}>

/**
 * One assistant turn: the natural-language prose (values already substituted
 * server-side, rendered as the {@link AnswerMarkdown} subset) followed by whatever
 * the host renders for its data parts. The lib is agnostic about what the data parts
 * are — the host injects `renderData`.
 */
export function Answer({ message, renderData, testId }: AnswerProps) {
  return (
    <div className={classes.answer} data-testid={testId}>
      <div className={classes.answerBody}>
        {/* Tokens are stripped before parsing, so a residual `{{ref}}` can never be
            mistaken for markdown. */}
        <AnswerMarkdown content={stripResidualTokens(message.text)} />
      </div>

      {renderData?.(message.data)}
    </div>
  )
}
